// French

export default {

  component: {
    jobAdList: {
      title: 'Postes vacants',
      jobs: 'emplois',
      noJobAds: 'Il n\'y a actuellement aucun poste vacant.',
    },

    jobAdCard: {
      openUntil: date => `Clôture le ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Merci.',
      readyInfo: 'Nous avons bien reçu votre candidature, le recruteur vous contactera bientôt.',
      luck: 'Bonne chance !',
    },

    jobAdSeeYou: {
      title: 'Merci.',
      description: 'Votre candidature est sauvegardée et nous vous avons envoyé un lien pour la reprendre plus tard.',
    },

    unpublished: {
      title: 'Non publiée',
      info: 'L’offre d’emploi n’a pas encore été publiée.',
    },
  },

  page: {},

}
